import { Injectable } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';

import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class FirebaseAuthGuard  {
  constructor(private auth: Auth) { }

  canActivate(): Observable<boolean> {
    return authState(this.auth).pipe(
      filter(user => !!user),
      take(1),
      map(_ => true),
    );
  }
}
